import clsx from 'clsx';
import React, { useCallback, useRef, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { root_path } from '../../../routes';
import { TIModal } from '../../BaseUI';
import StepBasicInfo from './StepBasicInfo';
import StepComplete from './StepComplete';
import StepEnableProfile from './StepEnableProfile';

const queryClient = new QueryClient();

const EnableProfileModal = ({
  isLoggedIn,
  isSubscriber,
  isTriggeredByComment,
  commentButtonText,
  isCommentForForum,
  handleSubmitComment,
  commentData, // TODO: remove when we render all comments from react components
  onModalComplete,
  buttonClasses,
}) => {
  // don't need this state (can pass from parents) once this component is always rendered by react components
  const [isOpen, setIsOpen] = useState(!isTriggeredByComment);
  const [isSaving, setIsSaving] = useState(false);
  const [step, setStep] = useState(0);
  const [profileEnabled, setProfileEnabled] = useState(false);
  const triggerCommentRef = useRef();

  const onClose = useCallback(() => {
    if (!!onModalComplete && step > 0) onModalComplete();

    // if user is commenting refresh page when modal closes
    // TODO don't refresh page when article comments are rendered from react
    const refreshOnClose = isTriggeredByComment && !isCommentForForum && profileEnabled;
    if (refreshOnClose) {
      const searchParams = new URLSearchParams(window.location.search);
      const currPage = searchParams.get('page');
      const reloadSamePage = currPage == commentData['page_to_reload'];
      if (!reloadSamePage) {
        searchParams.set('page', commentData['page_to_reload']);
        const newRelativePath = `${window.location.pathname}?${searchParams.toString()}`;
        window.history.replaceState(null, '', newRelativePath);
      }

      window.location.reload(reloadSamePage);
    }
    const redirectOnClose = !isTriggeredByComment && !profileEnabled;
    return redirectOnClose ? (window.location = root_path()) : setIsOpen(false);
  }, [isTriggeredByComment, profileEnabled, isCommentForForum, step]);

  const currentStep = () => {
    switch (step) {
      case 0:
        return (
          <StepEnableProfile
            nextStep={() => setStep(1)}
            isLoggedIn={isLoggedIn}
            isSubscriber={isSubscriber}
            isSaving={isSaving}
            setIsSaving={setIsSaving}
            setProfileEnabled={setProfileEnabled}
            isTriggeredByComment={isTriggeredByComment}
            isCommentForForum={isCommentForForum}
            handleSubmitComment={handleSubmitComment}
            commentData={commentData} // TODO: remove once article comments render from react
            ref={triggerCommentRef}
          />
        );
      case 1:
        return <StepBasicInfo nextStep={() => setStep(2)} />;
      case 2:
        return <StepComplete nextStep={onClose} />;
      default:
        onClose();
    }
  };

  return (
    <QueryClientProvider client={queryClient}>
      {isTriggeredByComment && (
        <button
          ref={triggerCommentRef}
          className={clsx('button button-submit button-small', buttonClasses)}
          type="button"
          disabled={isSaving}
          onClick={(e) => {
            if (!profileEnabled) {
              e.preventDefault();
              setIsOpen(true);
            }
          }}
        >
          {commentButtonText}
        </button>
      )}
      <TIModal
        isOpen={isOpen}
        parentClass="EnableProfileModal"
        disableScrollLock={false}
        onClose={onClose}
      >
        {currentStep()}
      </TIModal>
    </QueryClientProvider>
  );
};

export default EnableProfileModal;
